import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { DataResult, DataSourceRequestState } from '@progress/kendo-data-query';
import { HttpClient } from '@angular/common/http';
import { AppConstant } from 'src/app/app.constant';


@Injectable({
    providedIn: 'root'
})
export class LeaveManagementService {
    apiUrl: string;
    constructor(private appConstant: AppConstant, private httpClient: HttpClient) {
        this.apiUrl = this.appConstant.getUrl()
    }
    manageLeave(leave) {
        return this.httpClient.post(`${this.apiUrl}/manageLeave`, leave).pipe(
            map((response: any) => {
                return response;
            }))
    }
    updateLeave(leave) {
        return this.httpClient.post(`${this.apiUrl}/updateLeave`, leave).pipe(
            map((response: any) => {
                return response;
            }))
    }
    deleteLeave(id: number, userId: number) {
        return this.httpClient.delete(`${this.apiUrl}/deleteLeave/` + id + '/app/' + userId).pipe(
            map(data => data));
    }
    deleteLeaveTypes(leaveTypes) {
        return this.httpClient.post(`${this.apiUrl}/deleteLeaveTypes`, leaveTypes).pipe(
            map((response: any) => {
                return response;
            }))
    }
    manageLeaveType(types) {
        return this.httpClient.post(`${this.apiUrl}/manageLeaveType`, types).pipe(
            map((response: any) => {
                return response;
            }))
    }
    getLeaveTypeById(Id: number) {
        return this.httpClient.post(`${this.apiUrl}/getLeaveTypeById`, Id).pipe(
            map((response: any) => {
                return response;
            }))
    }
    getLeaveById(Id: number) {
        return this.httpClient.get(`${this.apiUrl}/getLeaveById/`+ Id).pipe(
            map((response: any) => {
                return response;
            }))
    }
    getAllLeaveByUser(reqData): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllLeaveByUser/`, reqData).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllLeaveByUserExcel(reqData) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/getAllLeaveByUser/`, reqData).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    getAllLeaveType(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllLeaveType/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllLeavesExcel(userId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/leaveListExcel/` + userId).pipe(map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    getAllLeaveForApproval(state: DataSourceRequestState): Observable<DataResult> {
        let params = {
            state: state
        }
        return this.httpClient.post(`${this.apiUrl}/getAllLeave/`, params).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    getAllLeaveForApprovalExcel(state: DataSourceRequestState) {
        let params = {
            state: state
        }
        return new Promise((resolve, reject) => {
            this.httpClient.post(`${this.apiUrl}/getAllLeave/`, params).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    // workflow status get API
    public getWorkFlowStatusByEntity(entityName: string) {
        return this.httpClient.get(`${this.apiUrl}/getWorkFlowStatusByEntity/` + entityName).pipe(
            map((response: any) => {
                return response.data
            })
        )
    }

}
